import React, {useState} from 'react';
import {Modal} from './Modal';
import {Choice} from '../types';

type AdminActionCommentModalProps = {
    show: boolean;
    action?: Choice;
    onCloseCancel: () => void;
    onCloseOk: (action: Choice, comments: string) => void;
    userIsSupport: boolean;
};

export const AdminActionCommentModal: React.FunctionComponent<AdminActionCommentModalProps> = ({
                                                                                                   show,
                                                                                                   action,
                                                                                                   onCloseCancel,
                                                                                                   onCloseOk,
                                                                                                    userIsSupport = false,
                                                                                               }): JSX.Element => {

    const [comments, setComments] = useState<string>('');
    const [snowInc, setSnowInc] = useState<string>('');
    const [validationErrors, setValidationErrors] = useState<any>({});

    return (
        show ?
            <Modal>
                <div className="modal-header">
                    <h5 className="modal-title">{action?.label}</h5>
                    <button type="button"
                            className="close"
                            tabIndex={-1}
                            onClick={() => {
                                onCloseCancel();
                                setComments('');
                            }}
                    >×
                    </button>
                </div>
                <div className="modal-body">
                    {userIsSupport &&
                        <div className="form-group">
                            <p>Provide SNOW Incident# for this Action</p>
                            <input
                                type="text"
                                className="form-control"
                                value={snowInc}
                                onChange={(e) => {
                                    setSnowInc(e.target.value);
                                }}
                            />
                            {validationErrors?.snowInc && <p className={'text-danger'}>A SNOW Incident# is required. Should begin with <em>INC</em></p>}
                        </div>
                    }
                    <p>Enter any notes / comments you want to attach to this admin activity</p>
                    <div className="form-group">
                            <textarea
                                className="form-control"
                                value={comments}
                                onChange={(e) => {
                                    setComments(e.target.value);
                                }}
                            />
                        {validationErrors?.comment && <p className={'text-danger'}>A comment required</p>}
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button"
                            className="btn btn-primary"
                            onClick={() => {
                                setValidationErrors({});
                                let userComment = comments;

                                if (userIsSupport) {
                                    let hasValidationErrors = false;
                                    if (!comments) {
                                        setValidationErrors(state => ({
                                            ...state,
                                            comment: true
                                        }));
                                        hasValidationErrors = true;
                                    }
                                    if (!snowInc || !snowInc.startsWith('INC')) {
                                        setValidationErrors(state => ({
                                            ...state,
                                            snowInc: true
                                        }));
                                        hasValidationErrors = true;
                                    }

                                    if (hasValidationErrors) {
                                        return;
                                    }

                                    userComment = `[${snowInc}] ${userComment}`;
                                }

                                action && onCloseOk(action, userComment)
                                setComments('');
                                setSnowInc('');
                                setValidationErrors({});
                            }}
                    >Submit
                    </button>
                </div>

            </Modal> : <div/>
    );
};
